import axiosInstance from "../axiosInstance";

// ── Service ─────────────────────────────────────────────────────────
export const kanbanService = {
  fetchData: async (obj, signal) => {
    try {
      const response = await axiosInstance.post("/kanban-data", obj, {
        signal,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Fetch summary metrics for the metric strip.
   * @returns {Promise<Object>}
   */
  fetchMetrics: async (id, obj, signal) => {
    try {
      const response = await axiosInstance.put(`/kanban-data/${id}`, obj, {
        signal,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
